import { AbstractType, InjectionToken, Injector, Type } from '@angular/core'

export class ServiceLocator {
  private static injector: Injector

  static initialize(injector: Injector) {
    ServiceLocator.injector = injector
  }

  static get<T>(token: Type<T> | AbstractType<T> | InjectionToken<T>) {
    return ServiceLocator.injector.get<T>(token)
  }
}
